import { render } from "./SelectScreenPlans.vue?vue&type=template&id=54e0382d"
import script from "./SelectScreenPlans.vue?vue&type=script&lang=js"
export * from "./SelectScreenPlans.vue?vue&type=script&lang=js"

import "./SelectScreenPlans.vue?vue&type=style&index=0&id=54e0382d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__